"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _core = require("../../../services/core");
var _async = _interopRequireDefault(require("react-select/async"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = _ref => {
  let {
    name,
    url,
    multiple = false
  } = _ref;
  const [fieldAutocomplete,, fieldHelper] = (0, _formik.useField)({
    name
  });
  const {
    locale
  } = (0, _react.useContext)(_core.ContextCore);
  let defaultValue = fieldAutocomplete.value ?? null;
  if (fieldAutocomplete.value && typeof fieldAutocomplete.value === 'object') {
    defaultValue = {
      value: fieldAutocomplete.value['@id'],
      label: fieldAutocomplete.value.name[locale]
    };
  }
  const [values, setValues] = (0, _react.useState)(defaultValue);
  const [timer, setTimer] = (0, _react.useState)();
  const fetchOptions = async terms => {
    const response = await _core._Api.get(url, {
      [`name.${locale}`]: terms
    });
    if (!response.data['hydra:member']) {
      return [];
    }
    return response.data['hydra:member'].map(item => {
      return {
        value: item['@id'],
        label: item.name[locale]
      };
    });
  };
  const loadAsyncOptions = async terms => {
    clearTimeout(timer);
    return new Promise(resolve => {
      const newTimer = setTimeout(() => {
        resolve(fetchOptions(terms));
      }, 500);
      setTimer(newTimer);
    });
  };
  const handleOnChange = option => {
    fieldHelper.setValue(option.value);
    setValues(option);
  };
  return /*#__PURE__*/_react.default.createElement(_async.default, {
    isMulti: multiple,
    loadOptions: loadAsyncOptions,
    onChange: handleOnChange,
    value: values,
    defaultOptions: true,
    className: "autocomplete-async",
    placeholder: /*#__PURE__*/_react.default.createElement("span", null, (0, _core._translate)(`registerapp_load_${name}`))
  });
};
exports.default = _default;